import { Controller } from '../utils/controller';
import { iframeResizer } from 'iframe-resizer';
import productController from './product_controller';

export default class extends Controller {
  static targets = ['output'];
  static requiredTargets = [];

  declare outputTarget: HTMLElement;
  declare readonly hasOutputTarget: boolean;

  // LOCAL STATE
  private resizer: iframeResizer;

  initialize() {
    if (this.hasOutputTarget) {
      this.resizer = iframeResizer(
        {
          checkOrigin: false,
          heightCalculationMethod: 'bodyScroll',
          waitForLoad: true,
          warningTimeout: 0,
          onScroll: () => {
            return false;
          },
          onMessage: ({ message }) => {
            const data = typeof message === 'string' ? JSON.parse(message) : message;

            if (data?._elc_action === 'addtobag') {
              const product = new productController(data.$addBtn);
              product.selectedskuValue = data.skuBaseId;
              product.quantityValue = data.INCREMENT;
              product.iframeId = data.iframeID;
              product.addToCart();
            }
          }
        },
        this.outputTarget
      );
    }

    return this.resizer;
  }
}
